export default "__VITE_ASSET__31776de3__"